import { Box } from "@mui/material";
import Link from "next/link";
import useTranslation from "../../../../../hooks/useTranslation";
import cssVars from "../../../../../styles/vars.module.scss"
import InstagramIcon from '../../../../../media/icons/instagram.svg'
import FacebookIcon from '../../../../../media/icons/facebook.svg'
import LinkedinIcon from '../../../../../media/icons/linkedin.svg'
import PinterestIcon from '../../../../../media/icons/pinterest.svg'

const Share = ({ product }) => {
    const { t } = useTranslation()
    return (
        <Box display="flex" alignItems="center">
            <Box fontWeight={500} mr="22px">{t("Share")}</Box>
            <Link href={`https://www.instagram.com/?url=${process.env.NEXT_PUBLIC_STORE_FRONT}${product?.url_key}.html`} target="_blank"
                style={{
                    width: 34, height: 34, backgroundColor: cssVars.extraLightGray, borderRadius: "50%",
                    padding: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "6px"
                }}>
                <InstagramIcon />
            </Link>
            <Link href={`https://www.facebook.com/sharer/sharer.php?u=${process.env.NEXT_PUBLIC_STORE_FRONT}${product?.url_key}.html`} target="_blank"
                style={{
                    width: 34, height: 34, backgroundColor: cssVars.extraLightGray, borderRadius: "50%",
                    padding: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "6px"
                }}>
                <FacebookIcon />
            </Link>
            <Link href={`https://www.linkedin.com/sharing/share-offsite/?url=${process.env.NEXT_PUBLIC_STORE_FRONT}${product?.url_key}.html`} target="_blank"
                style={{
                    width: 34, height: 34, backgroundColor: cssVars.extraLightGray, borderRadius: "50%",
                    padding: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "6px"
                }}>
                <LinkedinIcon />
            </Link>
            <Link href={`http://pinterest.com/pin/create/link/?url=${process.env.NEXT_PUBLIC_STORE_FRONT}${product?.url_key}.html`} target="_blank"
                style={{
                    width: 34, height: 34, backgroundColor: cssVars.extraLightGray, borderRadius: "50%",
                    padding: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                <PinterestIcon />
            </Link>
        </Box >
    );
}

export default Share;
